import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/papsi_close.svg'


const _hoisted_1 = { class: "pl-10 py-5 lg:py-10 lg:pl-10 flex flex-col h-screen" }
const _hoisted_2 = { class: "overflow-auto pr-10 -mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TermsOfUserView = _resolveComponent("TermsOfUserView")!
  const _component_CardView = _resolveComponent("CardView")!
  const _component_ContainerView = _resolveComponent("ContainerView")!

  return (_openBlock(), _createBlock(_component_ContainerView, {
    class: "flex w-full h-screen",
    gradient: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CardView, {
        max_width: "max-w-5xl xs:mb-16 m-auto",
        text_color: "bg-white text-theme-primary text-2xl lg:text-3xl"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "text-md cursor-pointer text-white absolute top-4 right-6 z-10 bg-white rounded-full p-2 hover:bg-gray-50",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Close",
                class: "w-6 h-6"
              }, null, -1)
            ])),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_TermsOfUserView)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}